
module.exports = {
    BoxSDK: {
        clientID: "kblwax7nf9r76aknem0h8qo6i8679rmr",
        clientSecret: "mBJtV3hTcQXRE41990F7X6wMlYpkI923",
        enterpriseID: "65809755"
    },
    redirectURL: 'http://localhost:3000/home'
  }